<template>
  <div class="desktop-wrapper">
    <main class="core-content">
      <header class="header-content">
        <div class="header-content-wrapper" :style="showImage ? backgroundStyle : ''">
          <div class="header-inner-content" :class="{'isMap' : showMap}">
            <div class="stack">
              <h2>{{ stack.meta.name }}</h2>
              <span class="date">{{ currentStack.edition.published_at | date }}</span>
            </div>
          </div>
          <div v-if="showMap" class="map">
            <DotMap :focusCountry="focusCountry" />
          </div>
          <div v-if="showImage"></div>
        </div>

        <div class="action-bar">
          <div class="action-div left">
            <div class="action-link" v-if="getPrevURL" @click="prevStory()">
              <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.33484 5.7352C-0.111613 6.15821 -0.111613 6.84518 0.33484 7.26819L6.04945 12.6827C6.4959 13.1058 7.22094 13.1058 7.66739 12.6827C8.11385 12.2597 8.11385 11.5728 7.66739 11.1497L3.89933 7.58291L14.8571 7.58291C15.4893 7.58291 16 7.09899 16 6.5C16 5.90102 15.4893 5.41709 14.8571 5.41709L3.9029 5.41709L7.66382 1.85026C8.11027 1.42724 8.11027 0.740271 7.66382 0.317259C7.21737 -0.105753 6.49233 -0.105753 6.04587 0.317259L0.331268 5.73181L0.33484 5.7352Z" fill="black"/>
              </svg>
              <span>Previous story</span>
            </div>
          </div>
          <Tracker class="tracker" :stats="currentStack.stats" :showComplete="false"/>
          <div class="action-div right">
            <div class="action-link" :class="{'highlight' : highlightNext}" v-if="getNextURL" @click="nextStory()">
              <span>{{ getNextLabel }}</span>
              <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.6527 7.26481C17.0992 6.84179 17.0992 6.15482 16.6527 5.73181L10.9381 0.317259C10.4917 -0.105753 9.76661 -0.105753 9.32016 0.317259C8.8737 0.740271 8.8737 1.42724 9.32016 1.85025L13.0882 5.41709H2.13047C1.49829 5.41709 0.987549 5.90101 0.987549 6.5C0.987549 7.09898 1.49829 7.58291 2.13047 7.58291H13.0847L9.32373 11.1497C8.87727 11.5728 8.87727 12.2597 9.32373 12.6827C9.77018 13.1058 10.4952 13.1058 10.9417 12.6827L16.6563 7.26819L16.6527 7.26481Z" fill="black"/>
              </svg>
            </div>
          </div>
        </div>
      </header>

      <div class="inner-content mid-content intro-content" v-if="getCurrentSlide.type === 'intro'" ref="scrollable">
        <h1>{{ getCurrentSlide.title }}</h1>

        <p>{{ currentStack.edition.synopsis }}</p>

        <div class="meta" v-if="currentStack.type === 'default' || currentStack.type === 'bio'">
          <div class="meta-item">
            <div class="icons">
              <div class="icon" v-for="(publisher, idx) in getStoryMeta.publishers.slice(0, 4)" :key="idx">
                <img :src="publisher.icon" :alt="publisher.name" />
              </div>
            </div>
            <span>Coverage from<br>{{ getStoryMeta.publishers.length }} sources</span>
          </div>

          <div class="meta-item">
            <svg width="22" height="25" viewBox="0 0 22 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.08789 0.978054C6.08789 0.438598 6.52649 0 7.06594 0H14.444C14.9834 0 15.422 0.438598 15.422 0.978054C15.422 1.51751 14.9834 1.95611 14.444 1.95611H7.06594C6.52649 1.95611 6.08789 1.51751 6.08789 0.978054ZM19.8911 4.11281C20.2746 3.72923 20.892 3.72923 21.2756 4.11281L21.2724 4.11113C21.656 4.49472 21.656 5.11212 21.2724 5.4957L19.5073 7.26078C20.7941 9.01071 21.5566 11.1699 21.5566 13.5051C21.5566 19.3261 16.8193 24.0634 10.9984 24.0634C5.17737 24.0634 0.440063 19.3261 0.440063 13.5051C0.440063 7.68408 5.17737 2.94678 10.9984 2.94678C13.7842 2.94678 16.3166 4.03336 18.2054 5.79843L19.8911 4.11281ZM11.0031 22.109C15.7435 22.109 19.6053 18.252 19.6053 13.5068L19.6054 13.5083C19.6054 11.3873 18.8352 9.44341 17.5561 7.9412C17.548 7.93378 17.5396 7.92755 17.531 7.9212L17.531 7.92119C17.5202 7.91316 17.5091 7.90492 17.498 7.89383C17.443 7.83881 17.4002 7.77616 17.3605 7.7135C15.7835 5.98813 13.5186 4.90465 11.0031 4.90465C6.26273 4.90465 2.40094 8.76483 2.40094 13.5068C2.40094 18.2472 6.26113 22.109 11.0031 22.109ZM13.9414 9.63086C13.9414 9.43164 14.0176 9.25586 14.1758 9.10938C14.3281 8.96289 14.5215 8.88672 14.7559 8.88672C15.0078 8.88672 15.2246 8.98047 15.4004 9.16797C15.5762 9.35547 15.6699 9.61328 15.6699 9.94141C15.6699 10.293 15.6172 10.6094 15.5117 10.8906C15.4062 11.1719 15.2656 11.4004 15.0957 11.5645C14.9258 11.7285 14.75 11.8574 14.5684 11.9512C14.3809 12.0449 14.1992 12.0977 14.0117 12.1211V11.5469C14.2695 11.4883 14.4863 11.3418 14.6621 11.1074C14.8379 10.873 14.9258 10.6152 14.9375 10.334C14.873 10.3809 14.791 10.3984 14.6973 10.3984C14.4746 10.3984 14.293 10.334 14.1523 10.1934C14.0117 10.0527 13.9414 9.86523 13.9414 9.63086ZM12.4414 10.9375L12.7988 9.97656C12.6113 9.84766 12.3711 9.74805 12.0781 9.66602C11.7793 9.58398 11.457 9.54297 11.1172 9.54297C10.5488 9.54297 10.0215 9.64844 9.53516 9.84766C9.04297 10.0527 8.62109 10.3457 8.26367 10.7207C7.90039 11.1016 7.61914 11.582 7.41406 12.1562C7.20898 12.7305 7.10938 13.375 7.10938 14.0781C7.10938 14.5762 7.16211 15.0273 7.2793 15.4375C7.39648 15.8477 7.54883 16.1875 7.74805 16.457C7.94141 16.7324 8.16992 16.9609 8.43359 17.1484C8.69727 17.3359 8.97266 17.4766 9.25977 17.5586C9.54688 17.6406 9.8457 17.6816 10.1504 17.6816C10.5312 17.6816 10.8945 17.623 11.2402 17.5C11.5859 17.3828 11.8906 17.207 12.1602 16.9844C12.4238 16.7617 12.6348 16.4863 12.793 16.1465C12.9453 15.8066 13.0273 15.4375 13.0273 15.0273C13.0273 14.2012 12.7754 13.5508 12.2832 13.082C11.791 12.6133 11.1465 12.3789 10.3613 12.3789C9.875 12.3789 9.45312 12.4785 9.10156 12.6719C8.74414 12.8652 8.48047 13.1055 8.31055 13.3867C8.35742 12.5723 8.62695 11.9043 9.11914 11.3828C9.61133 10.8613 10.25 10.5977 11.0469 10.5977C11.5918 10.5977 12.0547 10.7148 12.4414 10.9375ZM8.98438 16.2109C8.64453 15.9121 8.48047 15.5195 8.48047 15.0273C8.48047 14.5234 8.63867 14.125 8.9668 13.832C9.28906 13.5391 9.6875 13.3867 10.1621 13.3867C10.6309 13.3867 11.0293 13.5391 11.3516 13.832C11.6738 14.125 11.8379 14.5234 11.8379 15.0273C11.8379 15.5312 11.6738 15.9297 11.3516 16.2227C11.0293 16.5156 10.6309 16.6621 10.1621 16.6621C9.71094 16.6621 9.31836 16.5156 8.98438 16.2109Z" fill="#FFDE00"/>
            </svg>
            <span>Saving approx.<br>{{ getStoryMeta.time_saved }} mins</span>
          </div>

          <div class="meta-item">
            <div class="icons">
              <div class="icon" v-for="(country, idx) in getStoryMeta.countries.slice(0, 3)" :key="idx">
                <img :src="country.flag" :alt="country.name" />
              </div>
            </div>
            <span>Stories from<br>{{ getStoryMeta.countries.length }} countries</span>
          </div>
        </div>

        <div class="meta" v-if="currentStack.type === 'geo'" ref="scrollable">
          <div class="meta-item">
            <span class="stat">{{ getMapMeta.visited.count }}<span class="micro">/{{ getMapMeta.visited.total }}</span></span>
            <span>Countries visited</span>
          </div>

          <div class="meta-item">
            <span class="stat">{{ getMapMeta.streak }}</span>
            <span>Your streak</span>
          </div>

          <div class="meta-item">
            <span class="stat">{{ getMapMeta.max_streak }}</span>
            <span>Max streak</span>
          </div>
        </div>
      </div>

      <div class="inner-content mid-content" v-else-if="getCurrentSlide.type === 'outro'" ref="scrollable">
        <h1>{{ getCurrentSlide.title }}</h1>
        <DashboardTrack />
      </div>

      <div class="inner-content" v-else ref="scrollable">
        <h1>{{ getCurrentSlide.title }}</h1>
        
        <div v-for="(content, idx) in getCurrentContent" :key="idx" class="content-block">
          <h2 v-if="content.title">{{ content.title }}</h2>
          <div v-html="content.content"></div>
        </div>
      </div>
    </main>

    <aside class="aside">
      <section class="qr">
        <QRCode />
      </section>

      <section>
        <Dial />
      </section>

      <section class="stories">
        <div class="stories-heading">
          <h3>Dive deeper</h3>
        </div>
        <div class="inner-stories">
          <div class="story" v-for="story in getStories" :key="story.slug">
            <router-link :to="`/story/${story.slug}`" class="story-link">
              <div class="story-content-wrapper">
                <div class="story-content">
                  <h4 v-if="story.name" class="story-name">{{ story.name }}</h4>
                  <div class="story-meta-wrapper">
                    <span class="story-meta">
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.7812 6.5C11.7812 7.90067 11.2248 9.24398 10.2344 10.2344C9.24398 11.2248 7.90067 11.7812 6.5 11.7812C5.09933 11.7812 3.75602 11.2248 2.76559 10.2344C1.77517 9.24398 1.21875 7.90067 1.21875 6.5C1.21875 5.09933 1.77517 3.75602 2.76559 2.76559C3.75602 1.77517 5.09933 1.21875 6.5 1.21875C7.90067 1.21875 9.24398 1.77517 10.2344 2.76559C11.2248 3.75602 11.7812 5.09933 11.7812 6.5ZM0 6.5C0 8.22391 0.68482 9.87721 1.90381 11.0962C3.12279 12.3152 4.77609 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 4.77609 12.3152 3.12279 11.0962 1.90381C9.87721 0.68482 8.22391 0 6.5 0C4.77609 0 3.12279 0.68482 1.90381 1.90381C0.68482 3.12279 0 4.77609 0 6.5ZM5.89062 3.04688V6.5C5.89062 6.70312 5.99219 6.89355 6.1623 7.00781L8.5998 8.63281C8.8791 8.8207 9.25742 8.74453 9.44531 8.4627C9.6332 8.18086 9.55703 7.80508 9.2752 7.61719L7.10938 6.175V3.04688C7.10938 2.70918 6.8377 2.4375 6.5 2.4375C6.1623 2.4375 5.89062 2.70918 5.89062 3.04688Z" fill="black"/>
                      </svg>
                      {{ story.last_published_at | ago }}
                    </span>
                    <div class="item-mood" :class="getMood(story.mood).code">
                      <div class="item-mood-marker"></div>
                      <span>{{ getMood(story.mood).name }}</span>
                    </div>
                  </div>
                </div>

                <div onerror="this.style.display='none'" class="inner-image">
                  <img :src="story.image" :alt="story.name" />
                </div>
              </div>

              <span v-if="story.synopsis" class="story-stack">{{ story.synopsis }}</span>

              <ul class="meta" :title="story.last_published | date">
                <router-link v-for="(topic, idx) in story.topics.slice(0, 3)" :key="`story-${idx}-${story.slug}-topic-${topic.topic_code}`" :to="`/topic/${topic.topic_code}`" @click.native.stop>
                  <li>{{ topic.topic_name }}</li>
                </router-link>
              </ul> 
            </router-link>
          </div>
        </div>
      </section>
    </aside>
  </div>
</template>

<script>
  import API from 'app/axios';
  import Tracker from '@/components/v5/stacks/Tracker.vue';
  import QRCode from '@/components/v5/desktop/elements/QRCode.vue';
  import Dial from '@/components/v5/desktop/elements/Dial.vue';
  import DotMap from '@/components/v5/dotmap/DotMap.vue';
  import DashboardTrack from '@/components/v5/elements/DashboardTrack.vue';

  export default {
    data() {
      return {
        focusCountry: 'GB',
        highlightInterval: null,
        highlightNext: false,
        iTimeStart: (new Date()).getTime(),
      }
    },

    components: {
      Tracker,
      QRCode,
      Dial,
      DotMap,
      DashboardTrack
    },

    async mounted () {
      // console.log(`***** MOUNTED: ${this.stackSlug}`);
      await API.getStackShelves();
      if (this.stackSlug) {
        await API.getStack(this.stackSlug, this.editionSlug);
      }
      this.$userEngine.dialSnapshot();

      this.startHighlightInterval();

      this.$once('hook:beforeDestroy', () => {
        this.stopHighlightInterval();
      });
    },

    async activated() {
      // console.log(`***** ACTIVATED: ${this.stackSlug}`);
      await API.getStackShelves();
      if (this.stackSlug) {
        await API.getStack(this.stackSlug, this.editionSlug);
      }
    },

    watch: {
      '$route.params.stack': {
        handler() {
          // console.log(`\x1b[31mAPIStacks: `, this.stackSlug);
          // this.handleRoute();
          // console.log(`\x1b[32m[STACKS] ScrollUp!`);
          this.$refs?.scrollable?.scrollTo({
            top: 0,
            left: 0, 
            behavior: 'smooth',
          });
        }
      },
    },

    computed: {
      stackSlug() {
        return this.$route.params.slug; 
      },

      editionSlug() {
        return this.stack?.meta?.edition?.slug || '';
      },

      cardSlug() {
        return this.$route.params.stack;
      },

      stack() {
        return this.$store.getters.getStack(this.stackSlug);
      },

      collections() {
        return this.$store.getters.getStackShelves;
      },

      currentStack() {
        if (this.apiExempt || !this.collections) { return {} }

        const playlists = this.collections.flatMap(collection => collection.features);

        if (!this.stack?.meta?.slug) {
          return {};
        }

        return playlists.find(item => {
          const slug = item?.slug?.includes(':')
            ? item?.slug.split(':').pop()
            : item?.slug;
          return slug === this.stack?.meta?.slug;
        }) || {};
      },

      getStackMeta() {
        return this.stack?.meta;
      },

      getSlides() {
        return this.stack?.structure;
      },

      getCardSlides() {
        return this.stack?.structure?.filter((a) => a.type == 'story-card');
      },

      getCurrentSlide() {
        return this.stack?.structure?.find((a) => a.slug == this.cardSlug) || this.stack?.structure?.find((a) => a.type == 'intro') || {};
      },

      getCurrentSlideIndex() {
        return Math.max(this.stack?.structure?.findIndex((a) => a.slug == this.cardSlug), 0);
      },

      getCurrentContent() {
        return this.getCurrentSlide?.content?.body || '';
      },

      getNextURL() {
        let oNext = this.stack?.structure[this.getCurrentSlideIndex + 1] || {};
        return oNext.slug || false;
      },

      getNextLabel() {
        let oNext = this.stack?.structure[this.getCurrentSlideIndex] || {};
        if (oNext.type === 'intro') {
          return 'Start reading';
        }

        if (oNext.type === 'outro') {
          return 'Done';
        }

        return 'Next story';
      },

      getPrevURL() {
        let oNext = this.stack?.structure[this.getCurrentSlideIndex - 1] || {};
        return oNext.slug || false;
      },

      getIntroCard() {
        return this.stack?.structure?.find((a) => a.type == 'intro');
      },

      getStories() {
        return this.stack?.stories;
      },

      showImage() {
        if (['default', 'bio', 'focus'].includes(this.currentStack?.type) && this.featured) { return true; } return false;
      },

      showMap() {
        if (this.currentStack?.type === 'geo') { return true; } return false;
      },

      featured() {
        let images = [];
        let aSlugs = this.getCurrentSlide?.meta?.stories;
        this.stack?.stories?.forEach(story => {
          if (aSlugs?.length && !aSlugs.includes(story.slug)){
            return;
          }
          story?.articles?.forEach(article => {
            images.push({
              story: story.slug,
              article: article.slug,
              image: article.image,
              photo: article.photo,
              publisher: article.publisher,
              caption: article.name,
            });
          });
        });

        return images.filter(a => a.photo).sort( () => .5 - Math.random() ).pop();
      },

      backgroundStyle() {
        return {
          backgroundImage: `url('${this.featured?.image}')`,
          opacity: this.imageOpacity,
          transform: `translateY(${(1 - this.imageOpacity) * 100}px)`
        };
      },

      getStoryMeta() {
        return {
          publishers: [
            {
              "name": "The Guardian",
              "code": "theguardian",
              "domain": "theguardian.com",
              "icon": "https://nourished.news/images/sized/80x_/447a70f37e-qx90.png",
              "logo": "https://nourished.news/images/sized/200x_/510db326b6-qx90.png"
            },
            {
              "name": "New York Times",
              "code": "nytimes",
              "domain": "nytimes.com",
              "icon": "https://nourished.news/images/sized/80x_/897f420427-qx90.png",
              "logo": "https://nourished.news/images/sized/200x_/cff9090ecb-qx90.png"
            },
            {
              "name": "Business Insider UK",
              "code": "businessinsider",
              "domain": "uk.businessinsider.com",
              "icon": "https://nourished.news/images/sized/80x_/d6a46ac1c5-qx90.jpg",
              "logo": "https://nourished.news/images/sized/200x_/ec65ffb1ca-qx90.png"
            },
            {
              "name": "Politico",
              "code": "politico",
              "domain": "politico.com",
              "icon": "https://nourished.news/images/sized/80x_/53dbf6fea6-qx90.png",
              "logo": "https://nourished.news/images/sized/200x_/2b1262f5ba-qx90.png"
            },
            {
              "name": "New York Times",
              "code": "nytimes",
              "domain": "nytimes.com",
              "icon": "https://nourished.news/images/sized/80x_/897f420427-qx90.png",
              "logo": "https://nourished.news/images/sized/200x_/cff9090ecb-qx90.png"
            },
          ],
          time_saved: 6,
          countries: [
            {
              name: 'United Kingdom',
              locale: 'GB',
              flag: 'https://nourished.news/r/i/icons/country_flags/svg/gb.svg'
            },
            {
              name: 'United States',
              locale: 'US',
              flag: 'https://nourished.news/r/i/icons/country_flags/svg/us.svg'
            },
            {
              name: 'France',
              locale: 'FR',
              flag: 'https://nourished.news/r/i/icons/country_flags/svg/fr.svg'
            },
            {
              name: 'United Kingdom',
              locale: 'GB',
              flag: 'https://nourished.news/r/i/icons/country_flags/svg/gb.svg'
            },
          ]
        }
      },

      getMapMeta() {
        return {
          visited: {
            count: 12,
            total: 195
          },
          streak: 8,
          max_streak: 8,
        }
      }
    },

    methods: {
      routeStory(slug) {
        if (!slug) { return; }
        this.$router.push(`/story/${slug}`)
      },

      readMore() {
        this.$emit('readMore');
      },

      getMood(mood) {
        if (mood < -0.25) {
          return {
            code: 'negative',
            name: 'Negative'
          }
        } else if (mood > 0.25) {
          return {
            code: 'positive',
            name: 'Positive'
          }
        }

        return {
          code: 'neutral',
          name: 'Neutral'
        }
      },

      prevStory() {
        this.stopHighlightInterval();
        this.$router.back();
        this.startHighlightInterval();

        if (this.currentStack?.type !== 'geo') { return; }

        setTimeout(() => {
          const prevSlide = this.getCardSlides[this.getCurrentSlideIndex - 1] || {};
          if (prevSlide.type === 'intro' || prevSlide.type === 'outro') {
            this.focusCountry = 'GB';
          } else {
            if (prevSlide.meta?.locales?.length) {
              this.focusCountry = prevSlide.meta?.locales[0].iso.toUpperCase();
            }
          }
        }, 200);
      },

      nextStory() {
        this.stopHighlightInterval();
        const currentSlide = this.getSlides[this.getCurrentSlideIndex];

        // tracking
        let oPayload = {};
        oPayload.feature = /^pattern/.test(this.stackSlug) ? this.stackSlug.replace(/pattern:/, '') : `:${this.stackSlug}`;
        oPayload.edition = this.editionSlug;
        oPayload.card = this.cardSlug;
        oPayload.time = Math.ceil(((new Date()).getTime() - this.iTimeStart) / 1000);
        this.$userEngine.stackRead(oPayload);

        // reset the timer..
        this.iTimeStart = (new Date()).getTime();



        if (currentSlide?.end) {
          this.$router.push('/');
          return;
        } 

        
        this.$router.push(this.cardSlug ? this.getNextURL : `${this.$route.path}/${this.getNextURL}`);
        this.startHighlightInterval();

        if (this.currentStack?.type !== 'geo') { return; }
        
        setTimeout(() => {
          const nextSlide = this.getSlides[this.getCurrentSlideIndex + 1] || {};
          if (!nextSlide || nextSlide.type === 'intro' || nextSlide.type === 'outro') {
            this.focusCountry = 'GB';
          } else {
            if (nextSlide.meta?.locales?.length) {
              this.focusCountry = nextSlide.meta?.locales[0].iso.toUpperCase();
            }
          }
        }, 200);
      },

      startHighlightInterval() {
        this.highlightInterval = setInterval(() => {
          this.highlightNext = true;
        }, 5000);
      },

      stopHighlightInterval() {
        this.highlightNext = false;
        clearInterval(this.highlightInterval);
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .desktop-wrapper {
    max-width: $desktop-max-width;
    margin: 0 auto;
    display: grid;
    grid-template-columns: $desktop-grid-main $desktop-grid-aside;
    height: $desktop-grid-height;

    .core-content {
      position: relative;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      // border-left: 1px solid rgba($neutral-400, 0.25);
      border-right: 1px solid rgba($neutral-400, 0.25);

      @media (max-width: 1400px) {
        border-left: 0;
      }

      .header-content {
        background-size: cover;
        background-position: center;
        flex-shrink: 0;
        border-bottom: 1px solid rgba($neutral-400, 0.25);

        .header-content-wrapper {
          display: flex;
          align-items: center;
          position: relative;
          padding: 7rem 3rem;

          .map {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
          }

          .header-inner-content {
            display: flex;
            flex-direction: column;
            position: relative;
            z-index: 1;
            padding: 1.5rem;
            backdrop-filter: blur(10px);
            background: rgba($neutral-600, 0.6);
            border-radius: 10px;

            .darkmode & {
              background: rgba($neutral-100, 0.6);
            }

            &.isMap {
              backdrop-filter: blur(1px);
              background: rgba($neutral-600, 0.25);

              .darkmode & {
                background: rgba($neutral-100, 0.25);
              }
          }

            h2 {
              position: relative;
              font-family: 'Brawler';
              font-weight: normal;
              font-size: 1.75rem;
              z-index: 1;
            }

            .stack {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 1rem;

              .date {
                white-space: nowrap;
                padding-top: 5px;
              }
            }

            p {
              font-family: $ff-book;
              margin-bottom: 0;
              margin-top: 1rem;
            }
          }
        }

        .action-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.5rem 3rem;
          border-top: 1px solid rgba($neutral-400, 0.25);
          position: relative;
          z-index: 1;
          background: $neutral-600;

          .darkmode & {
            background: $neutral-100;
          }

          .action-div {
            display: flex;
            width: 12rem;

            &.left {
              justify-content: flex-start;
            }

            &.right {
              justify-content: flex-end;
            }
          }

          .action-link {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.7rem 1rem 0.75rem 1rem;
            font-weight: bold;
            border-radius: 6px;
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            
            span {
              padding-bottom: 1px;
            }

            svg path {
              fill: $neutral-100;

              .darkmode & {
                fill: $neutral-600;
              }
            }

            &:hover {
              color: $yellow-tone-4;

              svg path {
                fill: $yellow-tone-4;
              }

              .darkmode & {
                color: $yellow-tone-3;

                svg {
                  path {
                    fill: $yellow-tone-3;
                  }
                }
              }
            }

            &.highlight {
              background: $yellow-tone-3;
              color: $neutral-100;

              svg path {
                fill: $neutral-100;
              }

              &:hover {
                color: $neutral-100;
                transform: scale(1.03);
                svg path {
                  fill: $neutral-100;
                }
              }
            }
          }
        }
      }

      .inner-content {
        padding-bottom: 3rem;
        flex: 1;
        overflow-y: auto;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        &::-webkit-scrollbar {
          display: none;
        }

        &.mid-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          padding-left: 3rem;
          padding-right: 3rem;
        }

        &.intro-content {
          max-width: 550px;
          margin: 0 auto;
        }

        .actions {
          position: absolute;
          bottom: 0;
          right: 0;
          padding: 1rem;

          .btn {
            background: $yellow-tone-3;
            color: $neutral-100;
            padding: 0.75rem 1rem;
            border-radius: 8px;
          }
        }

        .image {
          position: relative;
          width: 100%;
          height: 20rem;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }

        h1 {
          display: inline-block;
          font-size: 2.5rem;
          font-family: 'Brawler';
          font-weight: normal;
          padding: 2rem 3rem 1.5rem 3rem;
        }

        .meta {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-gap: 1rem;
          margin-top: 2rem;

          .meta-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-align: center;
            font-size: 14px;

            .stat {
              font-family: 'Brawler';
              font-size: 26px;
              color: $neutral-100;
              margin: 0;

              .darkmode & {
                color: $neutral-600;
              }

              .micro {
                font-size: 12px;
                color: $neutral-100;

                .darkmode & {
                  color: $neutral-600;
                }
              }
            }

            span {
              display: inline-block;
              margin-top: 0.75rem;
              color: $neutral-400;
            }

            .icons {
              display: flex;
              align-items: center;
              margin-left: 10px;
              
              .icon {
                width: 24px;
                height: 24px;
                margin-left: -10px;

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 500px;
                  border: 2px solid $neutral-600;
                
                  .darkmode & {
                    border: 2px solid #0b0d0e;
                  }
                }
              }
            }
          }
        }

        .content-block {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          padding: 0 3rem;

          &:not(:last-child) {
            margin-bottom: 2rem;
          }

          h2 {
            margin-bottom: 1.5rem;
            font-size: 1.1rem;
            padding-bottom: 0.1rem;
            border-bottom: 2px solid $neutral-400;
            text-wrap: balance;
          }

          &::v-deep {
            * {
              font-family: $ff-book;
              font-size: 1.1rem;
              line-height: 1.8em;
            }

            .image {
              display: flex;
              flex-direction: column;
              width: 100%;

              &:not(:last-child) {
                margin-bottom: 1.5rem;
              }

              img {
                width: 100%;
                height: 15rem;
                object-fit: cover;
                border-radius: 10px;
              }

              .caption {
                font-size: 0.8rem;
                border-left: 1px solid $neutral-400;
                padding: 0.25rem 0.75rem;
                margin-top: 0.5rem;
              }
            }

            p:not(:last-child) {
              margin-bottom: 1.5rem;
            }

            ul {
              margin-bottom: 1rem;

              li {
                &:not(:last-child) {
                  margin-bottom: 1rem;
                }
              }
            }
          }
        }
      }
    }

    .aside {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      // border-right: 1px solid rgba($neutral-400, 0.25);

      @media (max-width: 1400px) {
        border-right: 0;
      }

      section {
        padding: 1rem;

        &.qr {
          padding: 1rem 2rem;

          @media (max-width: 820px) {
            padding: 1rem 1rem;
          }
        }

        &.stories {
          padding: 0;
        }
      }

      section:not(:last-child) {
        border-bottom: 1px solid rgba($neutral-400, 0.25);
      }

      .stories {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        padding-bottom: 3rem;
        overflow-y: auto;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
        &::-webkit-scrollbar {
          display: none;
        }

        .inner-stories {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 2rem 2rem 2rem 2rem;
        }

        .stories-heading {
          position: sticky;
          top: 0;
          padding: 2rem 2rem 1.5rem 2rem;
          border-bottom: 1px solid rgba($neutral-400, 0.25);
          backdrop-filter: blur(10px);
          background: rgba($neutral-600, 0.8);

          .darkmode & {
            background: rgba($neutral-100, 0.8);
          }

          h3 {
            font-family: 'Brawler';  
            font-weight: normal;
            font-size: 1.4rem;
            margin-bottom: 0.5rem;
          }
        }

        .story-link {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
          padding: 1rem 1rem 1rem 1rem;
          gap: 0.75rem;
        }

        .story-content-wrapper {
          display: flex;
          justify-content: space-between;
          width: 100%;
        }

        .story {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          width: 100%;
          background: rgba($neutral-400, 0.05);
          border-radius: 10px;
          color: $neutral-100;
          border-left: 2px solid transparent;
          cursor: pointer;
          transition: all 0.2s ease-in-out;

          .darkmode & {
            color: $neutral-600;
          }

          &:hover {
            background: rgba($neutral-400, 0.15);
          }

          .story-image {
            width: auto;
          }

          .inner-image {
            width: 4rem;
            height: 4rem;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 6px;
            }
          }

          .item-mood {
            display: flex;
            align-items: center;
            gap: 0.3rem;
            background: none;
            padding-top: 1px;

            .item-mood-marker {
              width: 7px;
              height: 7px;
              border-radius: 500px;
            }

            span {
              display: inline-block;
              font-size: 0.8rem;
              color: $neutral-400;
              padding-bottom: 1px;
            }

            &.positive {
              color: $green-tone-3;
              .item-mood-marker {
                background: $green-tone-3;
              }
            }

            &.neutral {
              color: $blue-tone-3;
              .item-mood-marker {
                background: $blue-tone-3;
              }
            }

            &.negative {
              color: $red-tone-3;
              .item-mood-marker {
                background: $red-tone-3;
              }
            }
          }

          .story-content {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;
            flex: 1;

            .story-name {
              font-size: 1.1rem;
              line-height: 140%;
            }

            .story-meta-wrapper {
              display: flex;
              align-items: center;
              margin-bottom: 0.25rem;

              .story-meta {
                display: flex;
                align-items: center;
                font-size: 0.8rem;
                color: $neutral-400;

                svg {
                  margin-top: 1px;
                  margin-right: 0.3rem;
                  
                  path {
                    fill: $neutral-400;
                  }
                }

                &:not(:last-child) {
                  &::after{
                    content: '|';
                    margin: 0 0.4rem;
                    color: $neutral-400;
                  }
                }
              }
            }
          }

          .story-stack {
            font-size: 0.8rem;
            color: $neutral-400;
            line-height: 140%;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }

          .meta {
            display: flex;
            flex-wrap: wrap;
            font-size: 0.8rem;
            gap: 0.5rem;
            padding-bottom: 0.5rem;

            li {
              color: $neutral-400;
              border-bottom: 1px solid $neutral-400;
              padding-bottom: 2px;
              transition: all 0.2s ease-in-out;

              &:hover {
                color: $neutral-100;
                border-bottom: 1px solid $neutral-100;

                .darkmode & {
                  color: $neutral-600;
                  border-bottom: 1px solid $neutral-600;
                }
              }
            }
          }
        }

        .story-image {
          width: 100%;
        }

        .inner-image {
          width: 100%;
          height: 10rem;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
          }
        }
        
        // .story {
        //   display: flex;
        //   align-items: flex-start;
        //   padding: 1rem;
        //   gap: 1rem;
        //   width: 100%;
        //   background: rgba($neutral-400, 0.08);
        //   border-radius: 10px;
        //   color: $neutral-100;
        //   border-left: 2px solid transparent;
        //   cursor: pointer;
        //   transition: all 0.2s ease-in-out;

        //   .darkmode & {
        //     color: $neutral-600;
        //   }

        //   .inner-image {
        //     width: 4.5rem;
        //     height: 3rem;

        //     img {
        //       width: 100%;
        //       height: 100%;
        //       object-fit: cover;
        //       border-radius: 6px;
        //     }
        //   }

        //   .story-content {
        //     display: flex;
        //     flex-direction: column;
        //     gap: 0.4rem;
        //     flex: 1;

        //     .story-name {
        //       font-family: 'Brawler';
        //       font-size: 1.1rem;
        //       line-height: 140%;
        //     }

        //     .story-stack {
        //       font-size: 0.8rem;
        //       color: $neutral-400;
        //       line-height: 140%;
        //       display: -webkit-box;
        //       -webkit-line-clamp: 2;
        //       -webkit-box-orient: vertical;
        //       overflow: hidden;
        //     }
        //   }

        //   &:hover {
        //     background: rgba($yellow-tone-3, 0.15);
        //     border-left: 2px solid $yellow-tone-3;
        //   }
        // }
      }
    }
  }
</style>